import {
  Image as ChakraImage,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
} from '@chakra-ui/react';
import { ReactNode } from 'react';

interface ProofPreviewModalProps {
  isOpen: boolean;
  onClose: () => void;
  fileUrl: string;
  renderPdfPreview?: (fileUrl: string) => ReactNode;
}

export const ProofPreviewModal = ({
  isOpen,
  onClose,
  fileUrl,
  renderPdfPreview,
}: ProofPreviewModalProps) => {
  const isPdf = fileUrl?.toLowerCase().endsWith('pdf');

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      closeOnEsc
      closeOnOverlayClick
      scrollBehavior="outside"
      size={isPdf ? '3xl' : 'full'}
      isCentered
    >
      <ModalOverlay />
      <ModalContent
        bg={isPdf ? undefined : 'transparent'}
        boxShadow={isPdf ? undefined : 'none'}
        h={isPdf ? undefined : '100dvh'}
        maxH={isPdf ? undefined : '100dvh'}
        maxW={isPdf ? undefined : '100vw'}
        p={isPdf ? '0' : { base: '56px 16px 24px', md: '72px 48px 32px' }}
      >
        <ModalCloseButton
          bg="white"
          borderRadius="full"
          boxShadow="md"
          color="gray.700"
          right={{ base: 4, md: 6 }}
          top={{ base: 4, md: 6 }}
          zIndex={1}
        />
        <ModalBody
          alignItems="center"
          display="flex"
          justifyContent="center"
          margin="auto"
          overflow={isPdf ? 'auto' : 'hidden'}
          p="0"
          w="full"
        >
          {isPdf
            ? renderPdfPreview?.(fileUrl)
            : fileUrl && (
                <ChakraImage
                  src={fileUrl}
                  alt="preview-image"
                  display="block"
                  maxH={{
                    base: 'calc(100dvh - 80px)',
                    md: 'calc(100dvh - 104px)',
                  }}
                  maxW={{
                    base: 'calc(100vw - 32px)',
                    md: 'calc(100vw - 96px)',
                  }}
                  objectFit="contain"
                  w="auto"
                />
              )}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
